import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { CookieManager } from 'react-cookie-manager';
import Cookies from 'js-cookie';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';

import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store';
import config from './config';
// import { injectStore } from './store/api/http';

// injectStore(store);

const app = (
  <CookieManager
    disableGeolocation
    translations={{
      title: '🍪 We use cookies',
      message:
        'FusionRemit uses strictly necessary cookies to operate the website and optional ' +
        'cookies for analytics and functionality. By clicking Accept all you consent to all ' +
        'cookies. You can also manage your preferences or reject optional cookies.',
      buttonText: 'Accept all',
      declineButtonText: 'Reject optional',
      manageButtonText: 'Manage preferences',
      privacyPolicyText: 'Cookie Policy',
    }}
    enableFloatingButton={true}
    showManageButton={true}
    privacyPolicyUrl={config.REACT_APP_COOKIES_POLICY_URL || config.REACT_APP_TENANT_WEBSITE}
    theme="light"
    displayType="popup"
    cookieKitId=""
    initialPreferences={{ Advertising: false, Analytics: false, Social: false }}
    onManage={(preferences) => {
      if (preferences) {
        if (preferences.Analytics && ReactGA && config.REACT_APP_GA_MEASUREMENT_ID !== '') {
          ReactGA.initialize(config.REACT_APP_GA_MEASUREMENT_ID);
        } else {
          const allCookies = Cookies.get();
          const cookieNames = Object.keys(allCookies);
          cookieNames.forEach((cookieName) => {
            if (cookieName.startsWith('_ga')) {
              Cookies.remove(cookieName);
            }
          });
        }
        if ((preferences.Advertising || preferences.Analytics) && TagManager && config.REACT_APP_TM_MEASUREMENT_ID !== '') {
          TagManager.initialize({ gtmId: config.REACT_APP_TM_MEASUREMENT_ID });
        }
      } else {
        const allCookies = Cookies.get();
        const cookieNames = Object.keys(allCookies);
        cookieNames.forEach((cookieName) => {
          if (cookieName.startsWith('_ga')) {
            Cookies.remove(cookieName);
          }
        });
      }
    }}
    onAccept={() => {
      if (ReactGA && config.REACT_APP_GA_MEASUREMENT_ID !== '') {
        ReactGA.initialize(config.REACT_APP_GA_MEASUREMENT_ID);
      }
      if (TagManager && config.REACT_APP_TM_MEASUREMENT_ID !== '') {
        TagManager.initialize({ gtmId: config.REACT_APP_TM_MEASUREMENT_ID });
      }
    }}
    onDecline={() => {
      const allCookies = Cookies.get();
      const cookieNames = Object.keys(allCookies);
      cookieNames.forEach((cookieName) => {
        if (cookieName.startsWith('_ga')) {
          Cookies.remove(cookieName);
        }
      });
    }}
  >
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </CookieManager>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
